<template>
  <ButtonNav
    :icon="getAppIcon(appId)"
    :label="i18n.global.t(`api.AppId.${appId}`)"
    :route-to="{
      name: appListMap[appId].route as any,
    }"
    :disabled="appStore.isNavigating"
    :color="appGroupColor"
  />
</template>

<script setup lang="ts">
import {
  i18n,
} from '@i18n';
import ButtonNav from '@qmulus/ui/components/app-navbar/button-nav.vue';
import {
  computed,
} from 'vue';

import {
  useAppStore,
} from '@/store/pinia/app.ts';
import {
  EAppId,
} from '@/types/app-type.ts';
import {
  appListMap,
  getAppIcon,
} from '@/types/app-util.ts';
import {
  appTileColorMap,
} from '@/utils/app-tile.ts';

const appStore = useAppStore();

const props = defineProps<{
  appId: EAppId,
}>();

const appGroupColor = computed<string | undefined>(() => {
  const app = appStore.appList?.find((activeApp) => activeApp.appId === props.appId);
  if (app === undefined) {
    return undefined;
  }
  return appTileColorMap[appStore.getAppGroup(app)];
});
</script>
